import { render } from "./activity-overlay.vue?vue&type=template&id=38dab917&scoped=true"
import script from "./activity-overlay.vue?vue&type=script&lang=js"
export * from "./activity-overlay.vue?vue&type=script&lang=js"

import "./activity-overlay.vue?vue&type=style&index=0&id=38dab917&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dab917"]])

export default __exports__